const networkingSummary = (
  <div className="networking-boost-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Why Networking Matters</h3>
      <ul className="list-disc pl-6">
        <li>Over 70% of jobs are found through networking—not just online applications.</li>
        <li>Helps you learn about different career paths and industries firsthand.</li>
        <li>Provides access to job referrals, mentorship, and insider job opportunities.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Where to Network</h3>
      <ul className="list-disc pl-6">
        <li>Alumni networks—many graduates are happy to share career advice.</li>
        <li>Conferences, hackathons, and career fairs—great for meeting industry professionals.</li>
        <li>LinkedIn—connect with people in your field and engage with their posts.</li>
        <li>Company events or speaker panels—stay after to introduce yourself.</li>
        <li>Casual meetups—networking can happen anywhere, even at social gatherings!</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How to Reach Out</h3>
      <ul className="list-disc pl-6">
        <li>Send a polite, concise LinkedIn message or email introducing yourself.</li>
        <li>Mention any shared connections, school, or common interests.</li>
        <li>Ask for a short coffee chat to learn about their career—not for a job!</li>
        <li>
          Be specific in your request (e.g., "I'd love to hear about your experience at
          [company].").
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Making the Most of Coffee Chats</h3>
      <ul className="list-disc pl-6">
        <li>Come prepared with questions about their role, industry, and career journey.</li>
        <li>
          Be genuinely curious and listen actively—networking is about building relationships.
        </li>
        <li>Keep it short (15–30 mins) and respect their time.</li>
        <li>Send a thank-you message afterward to show appreciation.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Turning Connections into Opportunities</h3>
      <ul className="list-disc pl-6">
        <li>Follow up occasionally—share updates or ask for advice on career moves.</li>
        <li>Stay engaged by commenting on their LinkedIn posts or sharing relevant articles.</li>
        <li>If they mention an opportunity, express interest but don’t push for a referral.</li>
        <li>
          Over time, strong relationships can lead to mentorship, job leads, or even collaborations.
        </li>
      </ul>
    </div>
  </div>
);

export default networkingSummary;
